import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store/store'
import {removeToken, getToken, getRefreshToken, setToken, setRefreshToken} from './auth'
import {refreshToken} from '../api/login'

function getApi () {
  return 'https://booksys.aimtyiot.cn/api/v1'
  // let aaa = window.location.protocol + '//' + window.location.host
  // // let scene = window.location.host
  // if (aaa === 'https://aqmtest.wecare-u.net') {
  //   return 'https://aqmtest.wecare-u.net/api/v1'
  // } else if (aaa === 'https://aqmwan.wecare-u.net:26688') {
  //   return 'https://aqmwan.wecare-u.net:26688/api/v1'
  // } else {
  //   return 'https://aqmtest.wecare-u.net/api/v1'
  // }
}

let isRefreshing = false
let requests = []

// 创建axios实例
const service = axios.create({
  baseURL: getApi(), // api的base_url
  timeout: 50000 // 请求超时时间
})

service.axios = axios

// request拦截器
service.interceptors.request.use(config => {
  // console.log('url', config.url)
  if (config.url === '/platform/logout' || config.url === '/platform/refreshToken') {
    config.headers['refreshToken'] = getRefreshToken()
  } else if (config.url === '/web/login') {
  } else {
    config.headers['accessToken'] = getToken()
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  return Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    const config = response.config
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    // 导出
    const headers = response.headers
    if (headers['content-type'] === 'application/octet-stream') {
      return response
    }
    // 获取返回信息
    const res = response.data
    // console.log(response.config.url)
    if (res.code === 200) {
      if (response.config.url === '/platform/logout') {
        location.href = '/'
      } else {
        return res
      }
    } else {
      if (response.config.url === '/platform/logout') {
        location.href = '/'
      } else {
        if (res.code === 0) {
          return res
        } else if (res.code === 401) {
          if (!isRefreshing) {
            isRefreshing = true
            refreshToken().then(res => {
              const data = res.data
              setToken(data.accessToken)
              setRefreshToken(data.refreshToken)
              config.headers['accessToken'] = getToken()
              requests.forEach((cb) => cb(data.accessToken))
              requests = []
              return service(config)
            }).catch(() => {
              MessageBox.confirm('你已被登出,请重新登录', '确定登出', {
                closeOnClickModal: false,
                showClose: false,
                showCancelButton: false,
                confirmButtonText: '重新登录',
                type: 'warning'
              }).then(() => {
                store.dispatch('Logout').then(res => {
                  location.href = '/'
                }).catch(() => {
                  store.dispatch('FedLogOut')
                  location.href = '/'
                })
                // removeToken()
                // removeRefreshToken()
                // // closeSub()
                // store.dispatch('FedLogOut').then(() => {
                //   location.href = '/'
                // })
              })
            }).finally(() => {
              isRefreshing = false
            })
          } else {
            // 正在刷新token，返回一个未执行resolve的promise
            return new Promise((resolve) => {
              // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
              requests.push((accessToken) => {
                config.headers['accessToken'] = accessToken
                resolve(service(config))
              })
            })
          }
        } else {
          Message({
            message: res.message,
            type: 'error',
            duration: 3 * 1000
          })
        }
      }
    }
  },
  error => {
    console.log(error)
    // console.log(error.response)
    // console.log('error', error.response.config)
    if (error.response && error.response.data && error.response.data.code === 401) {
      if (error.response.config.headers.refreshToken || error.response.config.headers.refreshToken === '') {
        // console.log('')
        MessageBox.confirm('你已被登出,请重新登录', '确定登出', {
          closeOnClickModal: false,
          showClose: false,
          showCancelButton: false,
          confirmButtonText: '重新登录',
          type: 'warning'
        }).then(() => {
          removeToken()
          // removeRefreshToken()
          // closeSub()
          store.dispatch('FedLogOut').then(() => {
            location.href = '/'
          })
        })
      } else {
        // accessToken 刷新
        console.log('accessToken 刷新', error.response.config)
      }
    } else {
      if (error.response.config.url === '/platform/logout') {
        MessageBox.confirm('你已被登出,请重新登录', '确定登出', {
          closeOnClickModal: false,
          showClose: false,
          showCancelButton: false,
          confirmButtonText: '重新登录',
          type: 'warning'
        }).then(() => {
          store.dispatch('Logout').then(res => {
            location.href = '/'
          }).catch(() => {
            store.dispatch('FedLogOut')
            location.href = '/'
          })
          // removeToken()
          // // removeRefreshToken()
          // // closeSub()
          // store.dispatch('FedLogOut').then(() => {
          //   location.href = '/'
          // })
        })
      } else {
        Message({
          message: error.response.data.message,
          type: 'error',
          duration: 3 * 1000
        })
      }
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js